<!--
value
1	心跳检测
2	客户接入
3	排队等待提醒
4	客户分配坐席成功
5	发送聊天消息
6	聊天消息消息应答
7	坐席状态变化
8	坐席转接
9	会话结束
10	客户或坐席信道建立应答
11	服务评价
-->
<!--
type
1	文本	包含纯文本和富文本
2	语音
3	图片
4	文件
5	链接
6	视频
7 机器人置顶问题列表
8 机器人猜你想问
9 机器人转人工组选择
11  留言
12 邀请评价链接
13 卡片消息
-->
<template>
  <el-alert
    v-show="page.showAlert"
    class="alert"
    title="历史会话中的机器人操作无效。如需咨询对应机器人，请重新进线。"
    type="warning"
    show-icon
    :closable="true"
    @close="page.showAlert = false"
  />
  <div class="mask" v-if="popoverMask" @click="closePop"></div>
  <div id="gundong" class="chat-msg flex-1"
    @touchstart="handleContainerTouchStart"
    @touchmove="handleTouchMove"
    @touchend="handleTouchEnd"
    @touchcancel="handleTouchEnd"
    @mousedown="handleMouseDown"
    @mousemove="handleMouseMove"
    @mouseup="handleMouseUp"
    @mouseleave="handleMouseUp">
    <div class="chat-msg__more">
      <span v-if="chatMsg.loading == 0">
        <i class="iconfont icon-bottom" />
        下拉查看更多
      </span>
      <span v-if="chatMsg.loading == 1">
        <i class="iconfont icon-loading" />
        数据加载中
      </span>
      <span v-if="chatMsg.loading == 2">没有更多记录啦</span>
    </div>
    <div class="chat-msg__list" v-for="(item, index) in msgList" :key="index" :id="`msg_${index}`">
      <!-- 历史消息分层 -->
      <el-divider v-if="item.isLast" border-style="dashed" content-position="center">历史消息</el-divider>
      <!-- 时间 -->
      <div class="chat-msg__time">{{ timeHandle(index) }}</div>
      <!-- 0历史消息,1系统消息,4异常消息 -->
      <div class="chat-msg__sys" v-if="[0, 1, 4].includes(item.value) || (item.value == 5 && [0, 1].includes(item.toType))">
        <div v-html="item.text"></div>
      </div>
      <!-- 聊天消息 2客服，3客户-->
      <div v-else :class="['chat-msg__item', 'flex', item.value === 3 ? 'flex-reverse' : '']">
        <!-- 头像 -->
        <msg-avatar :item="item" :agent-info="agentInfo"/>
        <div class="chat-msg__item-info">
          <el-popover
            :trigger="manual" 
            :visible="popoverList[index].visible"
            popper-class="my-popover1"
            placement="top"
            :width="isRevoke ? 150 : 80"
            :ref="getContextmenuRef"
            :disabled="showType === 1 "
            :teleported="false">
            <div class="flex flex-around">
              <div v-if="isRevoke" class="popover-content" @click="handleRevokeMsg(item, index)">
                <el-icon><Back /></el-icon>
                <div>撤回</div>
              </div>
              <div class="popover-content" @click="handleQuoteMsg(item, index)">
                <el-icon><ChatDotRound /></el-icon>
                <div>引用</div>
              </div>
            </div>
            <template #reference>
              <div @contextmenu.prevent="handleJudgeRevoke(item, index)" 
                  @touchstart="(e) => handleTouchStart(item, index, e)" 
                  @touchend="handleTouchEnd" 
                  @touchcancel="handleTouchEnd">
                <div class="chat-msg__info-name">
                  <!-- {{ item.value == 3 ? item.fromName : item.fromName }} -->
                  {{ getName(item) }}
                </div>
                <!-- 图片 -->
                <div class="chat-msg__info-img" v-if="item.type == 3">
                  <el-image :src="item.obj.url" :preview-src-list="[item.obj.url]" fit="cover">
                    <template #error>
                      <div class="error-slot">
                        <i class="iconfont icon-tupian" />
                      </div>
                    </template>
                  </el-image>
                  <div class="chat-msg__load" v-if="isBase64URl(item.obj.url)">
                    <i class="iconfont icon-loading" />
                  </div>
                </div>
                <!-- 视频 -->
                <div class="chat-msg__info-video" v-if="item.type == 6">
                  <video controls :src="item.obj.url" 
                    :ref="`videoRef_${index}`" 
                    @play="handlePlayVideo(index)" />
                  <div class="chat-msg__load" v-if="item.obj.url === ''">
                    <i class="iconfont icon-loading" />
                  </div>
                </div>
                <div
                  v-if="![3, 6, 13].includes(item.type)"
                  :class="['chat-msg__info-content', item.type == 7 && styleConfig.display === 2 ? 'pb-0' : '']"
                  :style="item.value == 3 ? { backgroundColor: bgColor } : {}"
                >
                  <!-- 文本 -->
                  <div class="chat-msg__info-text" v-if="item.type == 1 || (item.msgContentType === 20 && item.systemMsgType === 4)" v-html="filterSensitive(item.text)"></div>
                  <!-- 机器人答案满意度评价 -->
                  <answer-satisfy
                    :styleConfig="styleConfig"
                    :item="item"
                    :showType="showType"
                    :msgList="msgList"
                    :index="index"
                    :orgId="orgId"
                    @switch="handleSwitch"
                  />
                  <!-- 文件 -->
                  <file-msg :item="item" />
                  <!-- 机器人置顶问题列表 猜你想问 气泡样式 -->
                  <question-list :style-config="styleConfig" :item="item" :show-type="showType" @send="handleSendMsg" />
                  <!-- 机器人置顶问题列表  卡片样式 -->
                  <question-card :style-config="styleConfig" :item="item" :show-type="showType" @send="handleSendMsg" />
                  <!-- 留言 -->
                  <chat-leave-msg-replay-item v-if="item.type === 11" :message="item.obj" :orgId="orgId" />
                  <!-- 邀请评价链接 -->
                  <div
                    v-if="item.type === 12 && commentStyle.style === 0"
                    :style="{ color: '#3571F0' }"
                    class="chat-msg__info-text"
                    v-html="item.text"
                  ></div>
                  <!-- 机器人转人工选择 -->
                  <transfer-labor v-if="item.type === 9" :item="item" @switch="handleSwitch" />
                  <!-- 邀请评价消息气泡 -->
                  <comment-form
                    v-if="item.type === 12 && commentStyle.style === 1"
                    :styleConfig="styleConfig"
                    :commentStyle="commentStyle"
                    :orgId="orgId"
                    :showType="showType"
                    :chatId="chatId"
                    :commentType="commentType"
                  />
                </div>
                <div class="chat-msg_ai" v-if="item.isAi === 1" >由AI回复</div>
                <!-- 引用消息 -->
                <quote-msg v-if="item.quoteMsgContent" :quote-msg-content="item.quoteMsgContent" />
                <div
                  v-if="item.type === 12 && commentStyle.style === 0"
                  @click="handleComment"
                  class="chat-msg__info-star flex flex-item-center flex-around"
                >
                  <i class="iconfont icon-star" />
                  评价
                </div>
                <!-- 卡片消息 -->
                <card-msg v-if="item.type === 13" :item="item" @load="scrollToBottom" />
              </div>
            </template>
          </el-popover>
        </div>
      </div>
    </div>
    <!-- 机器人消息加占位符 -->
    <div class="chat-msg__item flex" v-if="props.btnLoading">
      <img v-if="styleConfig.avatar" class="chat-msg__item-avatar" :src="styleConfig.avatar" alt="" />
      <div v-else class="chat-msg__item-avatar icon flex flex-center flex-item-center">
        <i class="iconfont icon-p058jiqiren"></i>
      </div>
      <div class="chat-msg__item-info">
        <div class="chat-msg__info-content">
          <bot-loading />
        </div>
      </div>
    </div>
    <!-- 快捷入口 开始 -->
    <short-cut :style-config="styleConfig" :show-type="showType" @quickAccess="handleAccess" />
    <!-- 快捷入口 结束 -->
  </div>
</template>
<script setup>
import { Bottom, Loading, Download, Star, UserFilled, Picture } from '@element-plus/icons-vue'
import { deepCopy, compare, HtoRgba, timeFormat, isBase64URl } from '@/utils/index'
import ChatLeaveMsgReplayItem from './ChatLeaveMsgItem.vue'
import ShortCut from '@/components/robot/shortcut.vue'
import QuestionCard from '@/components/robot/questionCard.vue'
import QuestionList from '@/components/robot/questionList.vue'
import AnswerSatisfy from '@/components/robot/answerSatisfy.vue'
import TransferLabor from '@/components/robot/transferLabor.vue'
import BotLoading from '@/components/robot/BotLoading'
import QuoteMsg from '@/components/service/quote-msg.vue'
import CardMsg from '@/view/card/index.vue'
import CommentForm from '@/components/service/commentForm.vue'
import FileMsg from '@/components/service/fileMsg.vue'
import msgAvatar from '@/components/service/msgAvatar.vue'
import { isMobile } from '@/utils'
import {
  defineProps,
  computed,
  onMounted,
  watch,
  defineEmits,
  getCurrentInstance,
  nextTick,
  defineExpose,
  onBeforeUnmount,
  reactive,
  ref
} from 'vue'
const emit = defineEmits(['loadHistory', 'sendMsg', 'quickAccess', 'switch', 'comment'])
const props = defineProps({
  agentInfo: { type: Object, default: () => { } },
  styleConfig: { type: Object, default: () => {} },
  chatMsg: { type: Object, default: () => {} },
  orgId: { type: String },
  btnLoading: { type: Boolean, default: false },
  showType: { type: Number, default: 1 },
  chatId: { type: String, default: '' }, //机器人会话ID
  commentType: { type: Number } //评价类型
})
const getName = (item) => {
  if(item.msgContentType === 20 && item.systemMsgType === 4){
    return props.agentInfo?.agentName || ''
  }
  return item.fromName
}
// 消息列表
const popoverList = ref([])
const msgList = computed(() => {
  let list = deepCopy(props.chatMsg?.list)
  list.map((item)=>{
    const obj = {
      visible: false
    }
    popoverList.value.push(obj)
  })
  return list.sort(compare('time'))
})

const popoverMask = computed(() => {
  let index = popoverList.value.findIndex((item) => item.visible)
  return index !== -1
})

const page = reactive({
  showAlert: false,
  SenList: [], //敏感词
  isPulling: false,
  startY: 0,
  pullDistance: 0,
  longPressTarget: null,
  touchStartTime: 0,
  touchStartY: 0,
  isLongPress: false,
  isMouseDown: false
})

const config = computed(() => {
  let style = props.styleConfig.styleConfig || {}
  if (style && Object.keys(style).length > 0) {
    return style
  } else {
    return {
      themeColor: '#3571F0',
      placeholder: '请输入内容...',
      pageTitle: '',
      navigatorContent: { text: '' },
      quickAccess: [],
      navCommentTag: []
    }
  }
})
// 评价配置
const commentStyle = computed(() => {
  return props.styleConfig.commentStyle || {}
})
const bgColor = computed(() => {
  // return props.showType === 1 ? HtoRgba('#3571F0', 0.1) : HtoRgba(config.value.themeColor, 0.1)
  return HtoRgba(config.value.themeColor, 0.1) || HtoRgba('#3571F0', 0.1)
})
onMounted(() => {
  let ele = document.getElementById('gundong')
  if (ele) {
    ele.addEventListener('scroll', handleScroll)
  }
})
onBeforeUnmount(() => {
  let ele = document.getElementById('gundong')
  if (ele) {
    ele.removeEventListener('scroll', handleScroll)
  }
})
const handleScroll = (e) => {
  let p = e.target.scrollTop
  let h = e.target.scrollHeight - e.target.clientHeight
  if (p === 0) {
    pullDown()
  }
  if (h - p === 0) {
    pullUp()
  }
}
// 时间格式化
const timeHandle = (index) => {
  let time = props.chatMsg.list[index].time
  let currentIndex = index
  if (index != 0) {
    currentIndex = index - 1
  } else {
    currentIndex = index
  }
  let previewTime = props.chatMsg.list[currentIndex].time
  if (time - previewTime < 10 * 60 * 1000) {
    time = 0
  }
  if (time == 0) {
    return ''
  } else {
    let now = new Date()
    let timeObj = new Date(time)
    if (
      now.getFullYear() == timeObj.getFullYear() &&
      now.getMonth() == timeObj.getMonth() &&
      now.getDate() == timeObj.getDate()
    ) {
      return timeFormat(time, 'H:m')
    } else {
      return timeFormat(time, 'M月d日 H:m')
    }
  }
}
// 下拉
const pullDown = () => {
  // if (props.chatMsg.loading === 2) return
  emit('loadHistory', (index) => {
    let target = document.getElementById(`msg_${index - 1}`)
    let parent = document.getElementById('gundong')
    parent.scrollTop = target?.offsetTop - parent?.offsetTop
  })
}
// 上拉
const pullUp = () => {}
// 滚动到底部
const scrollToBottom = () => {
  nextTick(() => {
    let con = document.getElementById('gundong') // 获取对象
    setTimeout(() => {
      con.scrollTop = con.scrollHeight // 滚动高度
    }, 100)
  })
}

// 快捷点击
const handleSendMsg = (type, data) => {
  if (props.showType === 2) {
    return (page.showAlert = true)
  }
  // 常见问题
  if (type === 7) {
    let params = {
      dialogueId: props.chatId,
      menuId: data.knowledgeId,
      orgId: props.orgId,
      source: 0,
      type: 0,
      userId: localStorage.getItem('senderId') || ''
    }
    emit('sendMsg', { content: data, type: 102 })
    proxy.$http.post('/textrobot/app/menu/click', params).then(() => {
      params = null
    })
  } else if (type === 8) {
    emit('sendMsg', { content: data, type: 102 })
  }
}
// 获取敏感词
const getSensitiveList = async () => {
  let res = await proxy.$http.post('/app/custClient/ssensitiveword/listAll', { orgId: props.orgId })
  if (res.code === 0) {
    page.SenList = res.data.map((i) => i.wordContent)
  }
}
// 过滤敏感词
const filterSensitive = (text) => {
  if (page.SenList.length > 0) {
    page.SenList.forEach((i) => {
      if (text && text.indexOf(i) != -1) {
        let reg = new RegExp(i, 'g')
        let rw = new Array(i.length).fill('*').join('')
        let res = text.replace(reg, rw)
        text = res
      }
    })
  }
  return text
}
const { proxy } = getCurrentInstance()
watch(
  () => props.orgId,
  () => {
    if (props.orgId) {
      // 获取敏感词
      getSensitiveList()
    }
  },
  { immediate: true }
)
// 机器人快捷入口点击
const handleAccess = (data) => {
  emit('quickAccess', data)
}
// 机器人答案差评转人工
const handleSwitch = (data) => {
  emit('switch', data)
}
// 评价
const handleComment = () => {
  emit('comment')
}
// 播放视频
const handlePlayVideo = (index) => {
  let dom = proxy.$refs[`videoRef_${index}`][0] || {}
  if (dom.requestFullscreen) {
    dom.requestFullscreen()
  } else if (dom.mozRequestFullScreen) {
    dom.mozRequestFullScreen()
  } else if (dom.webkitRequestFullscreen) {
    dom.webkitRequestFullscreen()
  } else if (dom.msRequestFullscreen) {
    dom.msRequestFullscreen()
  }
}

// 撤回弹出框事件
const isRevoke = ref(false)
const handleJudgeRevoke = (item, index) => {
  // 机器人下不能撤回
  if(props.showType === 1){
    isRevoke.value = false
    return
  }
  let two = Date.now() - 2 * 60 * 1000
  if (item.time > two && item.value !== 2) {
    isRevoke.value = true
  } else {
    isRevoke.value = false
  }
  
  //  
  // if (props.showType === 1) { 
  //   isRevoke.value = false
  // }
  openPopover(index)
}

// 打开Popover
const openPopover = (index) =>{
  closePop()
  popoverList.value[index].visible = true
}
// 撤回消息
const handleRevokeMsg = (item, index) => {
  closePop()
  // 坐席分配成功的才能撤回
  if (proxy.$ws.status === 3) {
    proxy.$ws.revokeMsg(14, item.msgId)
  }
}
// 引用消息
const handleQuoteMsg = (item, index) => {
  closePop()
  // item.text = item.obj
  emit('cite', item)
}

const longPressTimer = ref()
const handleContainerTouchStart = (e) => {
  const ele = document.getElementById('gundong')
  if (ele && ele.scrollTop === 0) {
    page.touchStartTime = Date.now()
    page.touchStartY = e.touches[0].clientY
    page.isLongPress = false
  }
}

const handleTouchStart = (item, index, e) => {
  const ele = document.getElementById('gundong')
  if (ele) {
    page.touchStartTime = Date.now()
    page.touchStartY = e.touches[0].clientY
    page.isLongPress = false
    
    clearTimeout(longPressTimer.value)
    page.longPressTarget = { item, index }
    longPressTimer.value = setTimeout(() => {
      // 如果已经开始下拉，就不触发长按
      if (!page.isPulling) {
        page.isLongPress = true
        handleJudgeRevoke(page.longPressTarget.item, page.longPressTarget.index)
      }
    }, 300)
  }
}

const handleTouchMove = (e) => {
  const currentY = e.touches[0].clientY
  const ele = document.getElementById('gundong')
  
  if (ele && ele.scrollTop === 0) {
    const moveDistance = currentY - page.touchStartY
    const timeElapsed = Date.now() - page.touchStartTime
    
    // 如果移动距离超过阈值且时间较短，认为是下拉刷新
    if (moveDistance > 10 && timeElapsed < 300) {
      page.isPulling = true
      page.isLongPress = false
      clearTimeout(longPressTimer.value)
    }
    
    if (page.isPulling) {
      page.pullDistance = Math.max(0, currentY - page.touchStartY)
      if (page.pullDistance > 0) {
        e.preventDefault()
        ele.style.transform = `translateY(${page.pullDistance}px)`
      }
    }
  }
}

const handleTouchEnd = () => {
  const timeElapsed = Date.now() - page.touchStartTime
  
  // 如果触摸时间小于300ms且没有明显移动，可能是点击
  if (timeElapsed < 300 && Math.abs(page.pullDistance) < 10) {
    clearTimeout(longPressTimer.value)
  }
  
  if (page.isPulling) {
    const ele = document.getElementById('gundong')
    if (ele) {
      ele.style.transform = ''
      if (page.pullDistance > 50) {
        pullDown()
      }
    }
    page.isPulling = false
    page.pullDistance = 0
  }
  
  page.isLongPress = false
  page.longPressTarget = null
  page.touchStartTime = 0
  page.touchStartY = 0
}

// 收集所有popover
const contextmenuListRef = ref([])
const getContextmenuRef = (el) => {
  if (el) {
    contextmenuListRef.value.push(el)
  }
}
// 根据所有关闭popover
const closePop = () => { 
  popoverList.value.map((item) => {
    item.visible = false
  })
}

const handleMouseDown = (e) => {
  const ele = document.getElementById('gundong')
  if (ele && ele.scrollTop === 0) {
    page.isMouseDown = true
    page.touchStartTime = Date.now()
    page.touchStartY = e.clientY
    page.isLongPress = false
  }
}

const handleMouseMove = (e) => {
  if (!page.isMouseDown) return
  const currentY = e.clientY
  const ele = document.getElementById('gundong')
  if (ele && ele.scrollTop === 0) {
    const moveDistance = currentY - page.touchStartY
    const timeElapsed = Date.now() - page.touchStartTime
    // 如果移动距离超过阈值且时间较短，认为是下拉刷新
    if (moveDistance > 10 && timeElapsed < 300) {
      page.isPulling = true
      page.isLongPress = false
      clearTimeout(longPressTimer.value)
    }
    
    if (page.isPulling) {
      page.pullDistance = Math.max(0, currentY - page.touchStartY)
      if (page.pullDistance > 0) {
        e.preventDefault()
        ele.style.transform = `translateY(${page.pullDistance}px)`
      }
    }
  }
}

const handleMouseUp = () => {
  page.isMouseDown = false
  const timeElapsed = Date.now() - page.touchStartTime
  
  // 如果触摸时间小于300ms且没有明显移动，可能是点击
  if (timeElapsed < 300 && Math.abs(page.pullDistance) < 10) {
    clearTimeout(longPressTimer.value)
  }
  if (page.isPulling) {
    const ele = document.getElementById('gundong')
    if (ele) {
      ele.style.transform = ''
      if (page.pullDistance > 50) {
        pullDown()
      }
    }
    page.isPulling = false
    page.pullDistance = 0
  }
  
  page.isLongPress = false
  page.longPressTarget = null
  page.touchStartTime = 0
  page.touchStartY = 0
}

defineExpose({
  scrollToBottom
})
</script>
<style lang="less">
.my-popover1 {
  padding: 10px;
  background-color: #f8f8f8;
  border: unset;
  min-width: 100px !important;
  .el-popper__arrow::before {
    background-color: #f8f8f8;
    border: unset;
  }
}
.popover-content {
  font-weight: 400;
  font-size: 14px;
  line-height: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  img {
    width: 18px;
    height: 18px;
    margin-bottom: 6px;
  }
  .el-icon {
    margin-bottom: 5px;
    font-size: 20px;
    color: #606266;
  }
}
</style>
<style scoped lang="less">
.mask{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.chat-msg {
  background: #f0f1f2;
  overflow: auto;
  padding: 15px 0;

  &__more {
    text-align: center;
    padding: 10px;
    font-size: 12px;
    color: #999;
    span {
      padding: 0 5px;
    }
  }
  &__time {
    text-align: center;
    font-size: 12px;
    color: #999;
    line-height: 40px;
  }
  &__sys {
    text-align: center;
    color: #aaa;
    font-size: 13px;
    padding: 0 12px;
    div {
      margin-top: 15px;
    }
  }
  &__item {
    margin-top: 10px;
    text-align: left;
    padding: 0 20px;
  }
  &__item-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin: 3px 15px 0 0;
    i {
      color: #3571f0;
      font-size: 18px;
    }
  }
  .icon {
    background-color: #ffffff;
  }
  &__item-info {
    position: relative;
    color: #333;
    :deep(.comment-form__panel-body) {
      padding: 0;
    }
    :deep(.comment-form__panel-header) {
      padding: 0;
    }
    :deep(.comment-form__header-icon) {
      display: none;
    }
  }
  &__info-content {
    background-color: #ffffff;
    padding: 10px 15px;
    border-radius: 5px;
    margin-bottom: 5px;
    max-width: 300px;
    word-break: break-all;
    min-height: 41px;
    box-sizing: border-box;
    font-size: 14px;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  &__info-name{
    font-size: 12px;
    padding-bottom: 5px;
  }
  &__info-text {
    font-size: 14px;
    cursor: pointer;
    :deep(*) {
      padding: 0;
      margin: 0;
      line-height: 21px;
    }
    // 机器人回答问题包含了有序列表和无序列表样式控制
    :deep(ol li){
      margin-left: 20px;
    }
    :deep(ul li){
      margin-left: 20px;
    }
  }
  &__info-star {
    margin-top: 10px;
    font-size: 14px;
    color: #888888;
    padding: 4px 5px;
    width: 52px;
    background: #fcfcfc;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    cursor: pointer;
    > i {
      font-size: 18px;
    }
  }
  &__info-img {
    position: relative;
    :deep(.el-image) {
      width: 100px;
      height: 95px;
    }
    .error-slot {
      height: 100px;
      background-color: #e4e7eb;
      display: flex;
      justify-content: center;
      align-items: center;
      > i {
        font-size: 30px;
        color: #888888;
      }
    }
  }
  &__load {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.5);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    > i {
      font-size: 24px;
    }
  }
  &__info-video {
    position: relative;
    video {
      width: 132px;
      background: rgba(0, 0, 0, 0.5);
    }
  }
  &__info-file {
    font-size: 12px;
    text-align: left;
    position: relative;
  }
  &__file-icon {
    width: 42px;
    height: 42px;
    margin-right: 6px;
  }
  &__file-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    width: 100%;
    max-width: 150px;
  }
  &__file-size {
    color: #999;
  }
  .flex-reverse {
    flex-direction: row-reverse;
    .chat-msg__info-name{
      text-align: right;
    }
    /deep/ .el-tooltip__trigger{
      display: flex;
      flex-direction: column;
      align-items: end;
    }
  }
  .pb-0 {
    padding-bottom: 0;
  }
}
:deep(.el-divider__text){
  background-color: #f0f1f2;
}
:deep(.span-emoji) {
  display: inline-block;
  vertical-align: middle;
}
:deep(.inline-emoji) {
  width: 18px;
  height: 18px;
}
.chat-msg_ai{color: #bdbbbbd2;font-size: 12px;}
</style>
